import React, {Component} from 'react'
import PropTypes from 'prop-types'

class StaticsTableCreated extends Component {
    render() {
        const {data, loading, error} = this.props
        console.log(!!loading && !loading)

        return (
            <div className="StaticsTableCreated">
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th className='text-left'>SKU</th>
                        <th>Số lượng</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        loading === null && !!error && error.length > 0 && <tr>
                            <td colSpan={2} className='text-danger'>{error}</td>
                        </tr>
                    }

                    {
                        loading && <tr>
                            <td colSpan={2}>Loading...</td>
                        </tr>
                    }

                    {
                        !!data && data.length > 0 && data.map((item, index) =>
                            <tr key={index}>
                                <td className='SKU text-left'>{item.sku}</td>
                                <td className='Quantity'>{item.value}</td>
                            </tr>
                        )
                    }

                    {
                        error.length === 0 && !loading && data.length === 0 && <tr>
                            <td colSpan={2}>No data</td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>
        )
    }
}

StaticsTableCreated.propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.any,
    error: PropTypes.string
}

export default StaticsTableCreated